/**
 * @generated SignedSource<<142048724e2a834b2630386d847e40cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsComponent_ProductDetails$data = {
  readonly components: ReadonlyArray<{
    readonly __typename: string;
    readonly row?: {
      readonly detail?: {
        readonly title: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProductInfoComponentDetail_ProductInfoComponentDetailSchema">;
      } | null;
    } | null;
    readonly rows?: ReadonlyArray<{
      readonly detail?: {
        readonly title: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProductInfoComponentDetail_ProductInfoComponentDetailSchema">;
      } | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsComponent">;
  }> | null;
  readonly description: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsStoreProductInfo">;
  readonly " $fragmentType": "ProductDetailsComponent_ProductDetails";
};
export type ProductDetailsComponent_ProductDetails$key = {
  readonly " $data"?: ProductDetailsComponent_ProductDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsComponent_ProductDetails">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductInfoComponentDetailSchema",
        "kind": "LinkedField",
        "name": "detail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductInfoComponentDetail_ProductInfoComponentDetailSchema"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ProductInfoComponentRowInterface",
    "abstractKey": "__isProductInfoComponentRowInterface"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsComponent_ProductDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "components",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsComponent"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "row",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "ProductInfoRow",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "rows",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "ProductInfoSection",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetailsStoreProductInfo"
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};
})();

(node as any).hash = "49583b9a38e1cfd8502ff620b221c487";

export default node;
